import { endpoints } from '../api/endpoints';
import { queryKeys } from './queryKeys';
import { queryConfig } from './queryConfig';
import { createListQueryHook } from './queryFactory';

export const useResources = createListQueryHook({
  queryKey: queryKeys.resources(),
  endpoint: endpoints.resources,
  config: {
    staleTime: queryConfig.staleTime.short,
  },
});

